// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D6D6","content":"styles_content__3jldk"};